export default function useApiBaseUrl() {
  const apiBaseUrl = import.meta.env.VITE_API_BASE_URL;
  return { apiBaseUrl };
}
